import React from 'react';
import WOW from 'wowjs';
import { useEffect } from 'react';
import translate from '../translate';
import { useSelector } from 'react-redux';

function Mission() {
    const language = useSelector(state => state.view.selectedLanguage);
    const componentName = 'mission';

    useEffect(() => {
        const wow = new WOW.WOW({
            live: false,
            offset: 100,
            mobile: true,
        });
        wow.init();
    }, []);

    return (
        <div className="mission-section">
        <div className="container">
            <div className="row mt-none-30">
                <div className="col-xl-4 col-lg-6 col-md-6 mt-30">
                    <div className="mission-box wow fadeInUp" data-wow-delay="00ms" data-wow-duration="800ms">
                        <div className="icon icon__1">
                            <img src="assets/img/icons/mission-1.png" alt=""/>
                        </div>
                        <div className="content mt-25">
                            <h2 className="title">{translate(componentName, 'historyTitle', language)}</h2>
                            <p>{translate(componentName, 'historyDescription', language)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6 mt-30">
                    <div className="mission-box wow fadeInUp" data-wow-delay="200ms" data-wow-duration="800ms">
                        <div className="icon icon__2">
                            <img src="assets/img/icons/mission-2.png" alt=""/>
                        </div>
                        <div className="content mt-25">
                            <h2 className="title">{translate(componentName, 'missionTitle', language)}</h2>
                            <p>{translate(componentName, 'missionDescription', language)}</p>
                        </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-6 col-md-6 mt-30">
                    <div className="mission-box wow fadeInUp" data-wow-delay="400ms" data-wow-duration="800ms">
                        <div className="icon icon__3">
                            <img src="assets/img/icons/mission-3.png" alt=""/>
                        </div>
                        <div className="content mt-25">
                            <h2 className="title">{translate(componentName, 'visionTitle', language)}</h2>
                            <p>{translate(componentName, 'visionDescription', language)}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Mission;